import { createSlice } from "@reduxjs/toolkit";

const productsSlice = createSlice({
  name: "productsSlice",
  initialState: {
    products: [],
  },
  reducers: {
    addProduct(state, { payload }) {
      state.products.push(payload);
    },

    delProduct(state, { payload }) {
      const delId = payload;
      state.products = state.products.filter((product) => product.id !== delId);
    },

    setProducts(state, { payload }) {
      state.products = payload;
    },

    editProduct(state, { payload }) {
      const {id, data} = payload;
      
      const products = state.products;

      for (let i = 0; i < products.length; ++i) {
        if (products[i].id === id) {
          products[i] = {...products[i], ...data}
          break;
        }
      }
    },
  },
});

export default productsSlice.reducer;

export const { addProduct, delProduct, setProducts, editProduct } = productsSlice.actions;
